export const WAIST = 'waist';
export const LOW_WAIST = 'low waist';
export const HIP = 'hip';
